import React, { useContext, useEffect } from "react";
import { apiUrl } from "../../../Constants/Constants";
import { AuthContext } from "../../../Constants/AuthProvider";
import { useFetchWithToken } from "../../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { toast } from "react-toastify";
import styles from "./IsOnline.module.css";
const IsOnline = ({ item }) => {
  return (
    <>
      <div className={`${styles.label} ${styles.fuller}`}>
        <div className={styles.mkcol2}>
          {/* <div className={styles.statusLabel}>وضعیت:</div> */}
          {!item?.contain?.online ? (
            <div className={styles.statusSecure}>آف لاین</div>
          ) : (
            <>
              <div className={`${styles.statusSecure} ${styles.greenOnShow}`}>
                آن لاین
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default IsOnline;
